<template>
    <div class="public-bracket-header columns is-variable is-3">
        <div class="column" :class="{ 'is-half-desktop': hasSchedule }">
            <h3 class="is-size-5-mobile is-size-3 has-text-weight-semibold">{{ bracket.category }}</h3>
            <h4 class="is-size-6-mobile is-size-4 has-text-grey-light mb-3">
                {{ translate(bracket.typeKey) }}
                <span v-if="matsLabel && !hasSchedule" class="is-hidden-tablet"> · {{ matsLabel }}</span>
            </h4>

            <div class="bracket-stat-cards">
                <div v-if="bracket.totalCompetitors" class="bracket-stat-card">
                    <p class="bracket-stat-label"><i class="fa fa-users mr-1" />{{ translate("common.competitors") }}</p>
                    <p class="bracket-stat-value">{{ bracket.totalCompetitors }}</p>
                </div>
                <div class="bracket-stat-card">
                    <p class="bracket-stat-label"><i class="fas fa-bolt mr-1" />{{ translate("page.public_brackets.stat_fights") }}</p>
                    <p class="bracket-stat-value">{{ bracket.totalFights }}</p>
                </div>
                <div v-if="fightTime" class="bracket-stat-card">
                    <p class="bracket-stat-label"><i class="fa fa-clock mr-1" />{{ translate("page.public_brackets.stat_fight_time") }}</p>
                    <p class="bracket-stat-value">{{ fightTime }}</p>
                </div>
            </div>
        </div>

        <div v-if="hasSchedule" class="column is-flex is-flex-direction-column is-justify-content-center">
            <BracketEtaPanel class="is-hidden-mobile" :schedule="bracket.schedule" :event-timezone="eventTimezone" />
            <BracketEtaPanel class="is-hidden-tablet" :schedule="bracket.schedule" :event-timezone="eventTimezone" compact />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import timeFormatter from "../Common/timeFormatter";
    import type { PublicBracket } from "../Api/brackets";
    import BracketEtaPanel from "./BracketEtaPanel.vue";

    const props = defineProps<{
        bracket: PublicBracket;
        eventTimezone: string;
    }>();

    const hasSchedule = computed(() => props.bracket.schedule.segments.length > 0);
    const matsLabel = computed(() => props.bracket.selectedMats.map(mat => mat.name).join(", "));
    const fightTime = computed(() => {
        const seconds = props.bracket.fightTime ?? 0;
        return seconds > 0 ? timeFormatter.formatSecondsToMinutesAndSeconds(seconds) : null;
    });
</script>
